<template>
  <SogCard>
    <SogCardTitle>Vorlagen Recherche-Mails</SogCardTitle>
    <SogCardContent>
      <table
        v-if="!_selected"
        class="templates"
      >
        <tbody>
          <tr
            v-for="item in _items"
            :key="item.mailTypeId"
          >
            <td>{{ item.mailTypeText }}</td>
            <td>
              <SogCardActionButton
                mdi-icon="mdi-pencil"
                tooltip="Vorlage bearbeiten"
                @click="onSelect(item)"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <SogFlexColumn v-else>
        <div class="hint">
          {{ _selected.mailTypeText }}. Platzhalter: <b>{Absender}</b> (Name der freigebenden Person, in der Signatur), <b>{Kennzeichen}</b> (nur Betreff), <b>{Liste}</b>, <b>{Bestehende}</b>, <b>{Stelle}</b>, <b>{Datum}</b> (nur Erinnerung).
        </div>
        <SogTextBox
          v-model="_editSubject"
          placeholder="Betreff"
          width="100%"
        />
        <SogTextBox
          v-model="_editBody"
          placeholder="Text"
          :multiline="true"
          width="100%"
        />
      </SogFlexColumn>
    </SogCardContent>
    <SogCardActions v-if="_selected">
      <SogCardActionButton
        mdi-icon="mdi-content-save"
        tooltip="Vorlage speichern"
        @click="onSave"
      />
      <SogCardActionButton
        mdi-icon="mdi-cancel"
        tooltip="Abbrechen"
        @click="onCancel"
      />
    </SogCardActions>
  </SogCard>
</template>

<script setup lang="ts">
import {onMounted, ref, watch} from "vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import notificationService from "@/shared/services/NotificationService";
import apiRegistrationInquiry, {InquiryTemplate} from "@/modules/RegistrationInquiry/api";

interface Props {
  insurerId: string
}

const props = defineProps<Props>();

const _items = ref<InquiryTemplate[]>([]);
const _selected = ref<InquiryTemplate | undefined>(undefined);
const _editSubject = ref("");
const _editBody = ref("");

async function load() {
  _selected.value = undefined;
  _items.value = (await apiRegistrationInquiry.templates(props.insurerId)) ?? [];
}

// nur eine Art gleichzeitig: Auswahl einer Art öffnet deren Bearbeitung
function onSelect(item: InquiryTemplate) {
  _selected.value = item;
  _editSubject.value = item.subject ?? "";
  _editBody.value = item.body ?? "";
}

function onCancel() {
  _selected.value = undefined;
}

function onSave() {
  const t_item = _selected.value;
  if (!t_item) return;
  notificationService.showYesNo(
    "Vorlage speichern",
    `Die Vorlage „${t_item.mailTypeText}“ wird gespeichert. Bestehende Entwürfe bleiben unverändert. Fortfahren?`,
    async () => {
      const t_ok = await apiRegistrationInquiry.saveTemplates(props.insurerId, [{
        mailTypeId: t_item.mailTypeId,
        subject: _editSubject.value,
        body: _editBody.value,
      }]);
      if (t_ok) {
        notificationService.success("Vorlage wurde gespeichert");
        await load();
      }
    });
}

watch(() => props.insurerId, load);
onMounted(load);
</script>

<style scoped>
.hint {
  margin-bottom: 8px;
}

.templates td {
  padding: 4px 16px 4px 0;
  text-align: left;
}
</style>
